import { Grid2 as Grid, Typography } from '@mui/material';
import { LinkField } from 'framework/ui/field';
import { ACCOUNT_PATH } from 'domain/shared/account';
import { useDashboardProjectDataContext } from 'domain/projects/newProject/context/DashboardProjectContext';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import RelativeDateWithTooltip from 'domain/projects/newProject/shared/RelativeDateWithTooltip';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  BILLING_TYPE_LABELS,
  ENGAGEMENT_TYPE_OPTIONS,
  useProjectSecurityContext,
} from 'domain/shared/newProject';

const CommonGrid = ({ label, value }: { label: string; value: React.ReactNode }) => {
  return (
    <>
      <Grid size={6}>
        <Typography color="textSecondary">{label}</Typography>
      </Grid>
      <Grid size={6}>{value}</Grid>
    </>
  );
};

const ProjectMainInfo = () => {
  const { data: projectData } = useDashboardProjectDataContext();
  const { isAccessGranted } = useProjectSecurityContext();

  return (
    <Grid container spacing={1} size={12}>
      <CommonGrid
        label="Account"
        value={
          <LinkField
            linkText={projectData?.accountData?.accountName || EMPTY_VALUE_INDICATOR}
            label=""
            value={
              projectData?.accountData?.accountId
                ? `${ACCOUNT_PATH}/${projectData?.accountData?.accountId}`
                : EMPTY_VALUE_INDICATOR
            }
          />
        }
      />
      {isAccessGranted(ACCESS_INFO_SECTIONS.PROJECT_DIMENSION, ACCESS_INFO_ACTIONS.VIEW) && (
        <CommonGrid
          label={'Engagement type'}
          value={
            projectData?.projectDimension?.engagementType
              ? ENGAGEMENT_TYPE_OPTIONS[projectData.projectDimension.engagementType]
              : EMPTY_VALUE_INDICATOR
          }
        />
      )}
      <CommonGrid
        label="Billing type"
        value={
          projectData?.budget?.billingType ? BILLING_TYPE_LABELS[projectData.budget.billingType] : EMPTY_VALUE_INDICATOR
        }
      />
      <CommonGrid
        label="Project in progress"
        value={
          <RelativeDateWithTooltip
            date={projectData?.auditData?.activatedAt ?? projectData?.health?.createdAt}
            archivingDate={projectData?.auditData?.archivedAt}
            hideAgo
            showIn
          />
        }
      />
    </Grid>
  );
};

export default ProjectMainInfo;
